// extracted by mini-css-extract-plugin
export var wrapper = "description-module--wrapper--TiKUY";
export var title = "description-module--title--3jG-M";
export var desc = "description-module--desc--2Pjl1";
export var containerWhite = "description-module--containerWhite--3c9Cc";
export var descriptionImage = "description-module--descriptionImage--rdckd";
export var imageContainer = "description-module--imageContainer--1yx7M";
export var containerBlack = "description-module--containerBlack--c3WW9";
export var descContainer = "description-module--descContainer--ohG2p";